import { sequencing_center, cram_reference_list, experiments_view } from "../../../service/apis";
import { checkRowFilled } from "../components/UtilSubmissionTable";

// Get from backend list of column choices
export const fetchHeadersList = async (currentHeaders,token,apiEndpoint) => {
    // Sequecing center
    let res = await sequencing_center(token, apiEndpoint);
    let data = await res.json();
    let headerSequencingCentre = currentHeaders.find(item => item.id === "SequencingCentre")
    headerSequencingCentre.selection = data.map(item =>item.seqcentre_name);
    headerSequencingCentre.selection.unshift("----");
    // Instrument Model
    let instrumentModel = currentHeaders.find(item => item.id === "InstrumentModel");
    instrumentModel.selection = config.instrument_model;
    instrumentModel.selection.unshift("----");
    // Get Cram Reference
    res = await cram_reference_list(token, apiEndpoint);
    data = await res.json();
    let cramReference = currentHeaders.find(item => item.id === "CramRef");
    cramReference.selection = data.map(item => item.checksum + " - " + item.file_name);
    cramReference.selection.unshift("----");
    return currentHeaders;
}

// Get Local ExperimentsIDs 
export const fetchLocalExperimentsIDs = async(token,apiEndpoint, userGroups) => {
    /*Call API Endpoint*/
    let page = 1;
    let dataQuery = {"page" : page, "pageSize" : 1000, "fields" : ["LocalExperimentID"],
                     "filtered":[{"id":"Owner","value":userGroups}, {"id":"file_submission_close","value": ["false"]}]}
    let response =   await experiments_view(token,apiEndpoint, JSON.stringify(dataQuery))
    let data = await response.json();
    /*Query loop*/
    let listExperiments = [];
    let index = 0;
    for (let item of data["items"]){
        //2. Add option
        listExperiments.push({index:index, label:item["LocalExperimentID"]});
        index = index + 1;
    }
    // Query if pending pagess
    if (data["_meta"]["page"] < data["_meta"]["total_pages"]) {
        for (let item of data["items"]){
            //2. Add option
            listExperiments.push({index:index, label:item["LocalExperimentID"]});
            index = index + 1;
        }
        page = page +1;
        dataQuery["page"] = page;
        response = await experiments_view(token, apiEndpoint, JSON.stringify(dataQuery))
        data = await response.json();
    }
    return listExperiments;
}

export const fetchExperiments = async(token,apiEndpoint, search, page) => {
    /*Call API Endpoint*/
    let data_query = {"page" : page, "pageSize" : 100, "fields" : ["LocalExperimentID"],
                      "filtered":[{"id":"LocalExperimentID","value":[search]}, {"id":"file_submission_close","value": ["false"]}]}
    const response =   await experiments_view(token,apiEndpoint, JSON.stringify(data_query))
    const data = await response.json();
    /*Has More*/
    let hasMore = false;
    if (data["_meta"]["page"] < data["_meta"]["total_pages"]) {
      hasMore = true;
      page = page + 1;
    }
    //Create Select Options
    let options = [{value:0, label:'----'}];
    let value = 1;
    for (let item of data["items"]){
        //2. Add option
        options.push({value:value, label:item["LocalExperimentID"]});
        value = value + 1;
    }
    //Return settings for select experiments
    return {
        options: options,
        hasMore: hasMore,
        additional: {
          page: page,
        },
    };
}

export const getAPIKey = rowId => {
    //From column ID to Management API key
    let mapIds = {
        "ExperimentID":"RD_Connect_ID_Experiment", "File":"file", "FileType":"file_type",
        "CramRef":"cram_ref", "SequencingStrategy":"library_layout", "ReadLength":"read_length",
        "InstrumentModel":"instrument_model", "SequencingCentre":"seq_centre"
    }
    if (rowId in mapIds) return mapIds[rowId];
    else return "";
}

export const validateForm = async (formControls, headers) => {
    //Loop Form Controls
    for (let row of formControls){
        let checkRow = checkRowFilled(row, headers);
        for (let column of row){
            if (checkRow) {
                const value = column.value;
                //1. Check if the field is mandatory
                let columnHeader = headers.find(item => item.id === column.id);
                if (columnHeader.mandatory) {
                    if (Array.isArray(value)) {
                        //Check if selected values are valid options
                        let wrongValues = "";
                        for (let item of value) {
                            if(columnHeader.selection.indexOf(item) === -1 && item !== ""){
                                  wrongValues = wrongValues + " " + item;
                                  column.value.splice(column.value.indexOf(item), 1);
                            }
                        }
                        //Report errors
                        if (value.length === 0 || (value.length === 1 && (value[0] === "----" || value[0] === "")))
                        {
                            column.error = "This field is required.";
                        }
                        else if (wrongValues !== "") {
                            column.error = wrongValues + " not a valid options!!";
                        }
                        else {
                            column.error = "";
                        }
                    } else {
                        //Check in case of Combobox if selected value is valid
                        if (value === "" || value === "----")
                        {
                            if (column.error === "" ) column.error = "This field is required.";
                        }
                        else if(columnHeader.selection.length > 1 && columnHeader.selection.indexOf(value) === -1) {
                            column.error = value + " is not a valid option!!";
                        }
                        else {
                            column.error = "";
                        }
                    }
                }
            } else {
                //If row is empty then clean old errors
                column.error = "";
            }
        }
    }
}

export const getTsvFileLoadingReport = (loadedLocalIds,formControls) => {
    //Get a report about the results of TSV Loading
    let nonDefinedLocalIds = [...loadedLocalIds];
    let localIdsWithErrors = [];
    let openInformationDialog = false;
    for (let row of formControls) {
        const localId = row.find(item => item.id === "LocalExperimentID").value;
        // Search for error on submitted frow
        if (localId !== "") {
            for (let column of row) {
                if ('error' in column) {
                    if (column.error !== "") {
                        if (!localIdsWithErrors.includes(localId)) {
                            localIdsWithErrors.push(localId); 
                            openInformationDialog = true;
                        }
                    }
                }
            }
            // Delete from no defined preloaded experiments
            if (nonDefinedLocalIds.includes(localId)) {
                nonDefinedLocalIds = nonDefinedLocalIds.filter(value => value !== localId);
            }
        }
    }
    if (nonDefinedLocalIds.length > 0) openInformationDialog = true;
    return { "nonDefinedLocalIds": nonDefinedLocalIds, "localIdsErrors": localIdsWithErrors, "openInformationDialog": openInformationDialog};
}

export const parseSelectServerSide = (items,formItem,fieldId,valueChecked="") => {
    //Check data comming from server side API and try to update form field with new values
    if (items.length > 0){
        formItem.valueIndex = {value:0, label:items[0][fieldId]};
        formItem.value = items[0][fieldId];
        if (formItem.value !== "" && fieldId === "report_id") formItem.error = "";
    } else {
        if (formItem.value === "" && fieldId === "report_id") {
            formItem.error = valueChecked + " does not exits or you are not allowed to use it.";
        }
    }
};